(() => {
  const init = (root) => {
    if (!root || root.dataset.lmaReady === 'true') return;
    root.dataset.lmaReady = 'true';

    const progress = root.querySelector('[data-lma-progress]');
    let ticking = false;
    const updateProgress = () => {
      const rect = root.getBoundingClientRect();
      const distance = Math.max(root.offsetHeight - window.innerHeight, 1);
      const amount = Math.min(Math.max(-rect.top / distance, 0), 1);
      if (progress) progress.style.transform = `scaleX(${amount})`;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });
    updateProgress();

    const reveals = root.querySelectorAll('.lma-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      reveals.forEach((item) => observer.observe(item));
    } else {
      reveals.forEach((item) => item.classList.add('is-visible'));
    }

    const tabs = [...root.querySelectorAll('[data-lma-tab]')];
    const panels = [...root.querySelectorAll('[data-lma-panel]')];
    const selectTab = (tab) => {
      const key = tab.dataset.lmaTab;
      tabs.forEach((item) => {
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        item.tabIndex = item === tab ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.lmaPanel !== key; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        selectTab(next);
        next.focus();
      });
    });
    if (tabs.length) selectTab(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);

    const gallery = root.querySelector('[data-lma-gallery]');
    if (gallery) {
      const slides = [...gallery.querySelectorAll('[data-lma-slide]')];
      const count = gallery.querySelector('[data-lma-count]');
      let active = 0;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== active; });
        if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      };
      gallery.querySelector('[data-lma-prev]')?.addEventListener('click', () => show(active - 1));
      gallery.querySelector('[data-lma-next]')?.addEventListener('click', () => show(active + 1));
      show(0);
    }
  };

  const boot = () => document.querySelectorAll('[data-lma-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
